import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; // Tailwind and general styles
import './App.css';   // ✅ Import your print styles here

console.log('App type:', typeof App); // Debug: Should log 'function'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);